import { render, staticRenderFns } from "./vendorStoreDetailsDashboard.vue?vue&type=template&id=44d63f09&scoped=true&"
import script from "./vendorStoreDetailsDashboard.vue?vue&type=script&lang=js&"
export * from "./vendorStoreDetailsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d63f09",
  null
  
)

export default component.exports